import { Link } from 'react-router-dom';

const DashboardStatsGrid = ({ dashboards }) => {
  console.log('DashboardStatsGrid dashboards:', dashboards);
  return (
    <>
      <div className='modern-stats-container'>
        {/* Total Clients */}
        <div className='row mb-4'>
          <div className='col-lg-3 col-md-6 mb-3'>
            <div className='modern-stat-card modern-primary'>
              <div className='modern-card-content'>
                <div className='modern-icon-wrapper'>
                  <i className='fas fa-users modern-icon'></i>
                </div>
                <div className='modern-text-content'>
                  <Link to='/clients' className='modern-stat-link'>
                    <div className='modern-stat-title'>Total Clients</div>
                    <div className='modern-stat-number'>
                      {dashboards && dashboards.total_client
                        ? dashboards.total_client
                        : 0}
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Client Status Stats */}
          {dashboards &&
            dashboards.status_stats &&
            dashboards.status_stats.map((item, index) => (
              <div key={index} className='col-lg-3 col-md-6 mb-3'>
                <div
                  className={`modern-stat-card ${
                    item._id === '62b2a81edb1f21d46398f0c5'
                      ? 'modern-danger'
                      : 'modern-secondary'
                  }`}
                >
                  <div className='modern-card-content'>
                    <div className='modern-icon-wrapper'>
                      <i className='fas fa-chart-pie modern-icon'></i>
                    </div>
                    <div className='modern-text-content'>
                      <Link
                        to={`/clients?exact[status]=${item._id}`}
                        className='modern-stat-link'
                      >
                        <div className='modern-stat-title'>
                          {item.status ? item.status : 'Other Clients'}
                        </div>
                        <div className='modern-stat-number'>{item.count}</div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>

        {/* Client Review Status */}
        <div className='modern-section-header'>
          <h6 className='modern-section-title'>
            <i className='fas fa-star me-2'></i>
            Client Review Status
          </h6>
        </div>
        <div className='row mb-4'>
          {dashboards &&
            dashboards.client_review_status_array &&
            dashboards.client_review_status_array.map((item, index) => (
              <div key={index} className='col-lg-3 col-md-6 mb-3'>
                <div className='modern-stat-card modern-info'>
                  <div className='modern-card-content'>
                    <div className='modern-icon-wrapper'>
                      <i className='fas fa-star modern-icon'></i>
                    </div>
                    <div className='modern-text-content'>
                      <Link
                        to={`/clients?exact[review_status]=${item._id}`}
                        className='modern-stat-link'
                      >
                        <div className='modern-stat-title'>
                          {item._id ? item._id : 'Other Clients'}
                        </div>
                        <div className='modern-stat-number'>{item.count}</div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>

      <style jsx>{`
        .modern-stats-container {
          margin-bottom: 30px !important;
          padding: 0 15px !important;
        }

        .modern-section-header {
          margin: 30px 0 20px 0 !important;
          padding: 0 15px !important;
        }

        .modern-section-title {
          color: #495057 !important;
          font-size: 14px !important;
          font-weight: 600 !important;
          margin: 0 !important;
          display: flex !important;
          align-items: center !important;
          padding: 10px 0 !important;
        }

        .modern-stat-card {
          background: #ffffff !important;
          border-radius: 12px !important;
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08) !important;
          border: 1px solid #e9ecef !important;
          height: 110px !important;
          transition: all 0.3s ease !important;
          position: relative !important;
          overflow: hidden !important;
          padding: 0 !important;
          margin: 0 !important;
        }

        .modern-stat-card:hover {
          transform: translateY(-3px) !important;
          box-shadow: 0 6px 25px rgba(0, 0, 0, 0.15) !important;
        }

        .modern-card-content {
          padding: 20px !important;
          height: 100% !important;
          display: flex !important;
          align-items: center !important;
          gap: 15px !important;
        }

        .modern-icon-wrapper {
          width: 50px !important;
          height: 50px !important;
          border-radius: 12px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          flex-shrink: 0 !important;
          background: #6c757d !important;
        }

        .modern-primary .modern-icon-wrapper {
          background: linear-gradient(135deg, #007bff, #0056b3) !important;
        }

        .modern-danger .modern-icon-wrapper {
          background: linear-gradient(135deg, #e41d2e, #c82333) !important;
        }

        .modern-secondary .modern-icon-wrapper {
          background: linear-gradient(135deg, #6c757d, #545b62) !important;
        }

        .modern-info .modern-icon-wrapper {
          background: linear-gradient(135deg, #17a2b8, #138496) !important;
        }

        .modern-icon {
          font-size: 18px !important;
          color: #ffffff !important;
        }

        .modern-text-content {
          flex: 1 !important;
          min-width: 0 !important;
        }

        .modern-stat-link {
          text-decoration: none !important;
          color: inherit !important;
          display: block !important;
        }

        .modern-stat-link:hover {
          text-decoration: none !important;
          color: inherit !important;
        }

        .modern-stat-title {
          font-size: 12px !important;
          color: #6c757d !important;
          font-weight: 500 !important;
          margin-bottom: 8px !important;
          line-height: 1.3 !important;
          display: block !important;
        }

        .modern-stat-number {
          font-size: 32px !important;
          font-weight: 700 !important;
          color: #212529 !important;
          line-height: 1 !important;
          display: block !important;
        }

        .modern-primary .modern-stat-number {
          color: #007bff !important;
        }

        .modern-danger .modern-stat-number {
          color: #e41d2e !important;
        }

        .modern-info .modern-stat-number {
          color: #17a2b8 !important;
        }

        /* Override any existing dashboard styles */
        .modern-stats-container .dashboard-stat,
        .modern-stats-container .report-title,
        .modern-stats-container .report-stat {
          display: none !important;
        }

        @media (max-width: 768px) {
          .modern-stat-card {
            height: 100px !important;
          }

          .modern-card-content {
            padding: 15px !important;
            gap: 12px !important;
          }

          .modern-icon-wrapper {
            width: 40px !important;
            height: 40px !important;
          }

          .modern-icon {
            font-size: 16px !important;
          }

          .modern-stat-number {
            font-size: 26px !important;
          }
        }
      `}</style>
    </>
  );
};

export default DashboardStatsGrid;
